const GUEST_ID_KEY = 'guestId';
const DISPLAY_NAME_KEY = 'displayName';

/**
 * A stable per-browser id so guests keep their attempts and their leaderboard
 * position across sessions. Generated once and reused thereafter.
 */
export const getGuestId = (): string => {
  let guestId = localStorage.getItem(GUEST_ID_KEY);
  if (!guestId) {
    guestId = Math.random().toString(36).slice(2, 11);
    localStorage.setItem(GUEST_ID_KEY, guestId);
  }
  return guestId;
};

/** The name a guest chose for the leaderboard, if they've set one. */
export const getDisplayName = (): string | null =>
  localStorage.getItem(DISPLAY_NAME_KEY);

export const setDisplayName = (name: string): void => {
  const trimmed = name.trim().slice(0, 24);
  if (trimmed) {
    localStorage.setItem(DISPLAY_NAME_KEY, trimmed);
  } else {
    localStorage.removeItem(DISPLAY_NAME_KEY);
  }
};
